import moment from 'moment';
import momentNL from 'moment/locale/nl';
import { v4 as uuid } from "uuid";

//class CalenderHelperClass2 {
//    }

class CalenderHelperClass {
    static onHoverClassName = "hover";
    static onDragHoverClassName = "draghover";
    
    testval = null;
    constructor() {
    }

    static currentWeek=() => {
        let currentWeek = moment().format("W");
        return currentWeek;
    }

    static getDays=() => {
        let days = moment.weekdays();
        let sunday = days.shift();
        days.push(sunday);
        
        return days;
    }


    
    static calculateTime=(startDate, endDate, totalHoursDay) => {
        let totalHours = parseInt(endDate / (30 * 60 * 1000)) - parseInt(startDate/ (30 * 60 * 1000));
        let projectHours = (parseInt(totalHours)/parseFloat(totalHoursDay));
        
        return projectHours;
    }
    
    
    static canEdit(item) {
        let retVal = false;
        if(item?.isOwner) {
            retVal = true;
        } else if(item?.rights) {
            retVal = item?.rights?.can_edit;
        }
        return retVal;
    }

    static canDelete(item) {
        let retVal = false;
        if(item?.isOwner) {
            retVal = true;
        } else if(item?.rights) {
            retVal = item?.rights?.can_delete;
        }
        return retVal;
    }

    
    static removeEvent = (items, item) => {
        let newItems = [];
        for(let i in items) {
            if(items[i]["key"].trim() != item["key"].trim()) {
                newItems.push(items[i]);
            }
        }
        newItems = this.sortEvents(newItems);
        return newItems;
    }

    static sortEvents = (items) => {
        items.sort(function(a, b) {
const nameA = a.start_at; // ignore upper and lowercase
  const nameB = b.start_at; // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;            
        })
        
        
        return items;
    }

    static addEvent = (items, item) => {
        items.push(item);
        items = this.sortEvents(items);
        /*
        for(let i in items) {
            if(items[i]["key"] == item["key"]) {
                delete items[i]; 
            }
        }
        
        */
        return items;
    }
    
    static onDragEnter = (event) => {
        
    }

    static addCloneToView = (cloneElement = null) => {
        let root = document.getElementById("days");
        let clone = document.getElementById("clone");
        if(clone) {
            //clone.removeEventListener('dragover', function(ev){ev.preventDefault()});
            clone.remove();
            clone = null;
        }
        cloneElement.addEventListener('dragover', function(ev){ev.preventDefault()})
        if(clone && clone != cloneElement) {
         //root.replaceChild(clone, element);   
        } else if(!clone) {
            root.appendChild(cloneElement);
        }
        
        }
    
    static setCloneElement = (original = null) => {
        let element = original.cloneNode(true);
        let root = document.getElementById("days");
        let rootrec = root.getBoundingClientRect();
        let rec = original.getBoundingClientRect();
        
        let zoomFactor = 1.2;
        
        element.style.width = rec.width+"px";
        element.style.left = (((rec.left - rootrec.left)/zoomFactor) - (rec.width/6))+"px";;
        element.style.top = (((rec.top - rootrec.top)/zoomFactor)- (rec.height/6))+"px";;
        element.style.minHeight = rec.height + (rec.height/6)+"px";
        element.style.width = rec.width + (rec.width/6)+"px";
        element.style.height = (rec.height*2)+"px";
        
        element.style.position = 'absolute';
        element.style.border = '1px solid #d2d2d2';
        element.style.zindex = 9999;
        element.style.zoom = zoomFactor;
        element.id = "clone";
        
        this.addCloneToView(element)        
        
        
        return element;
    }
    
    static createDossierItem = (day, dossierItem) => {
        let item = {};
        //item.changedDayKey = day.daykey;
        item.name =(dossierItem.item.name) ? dossierItem.item.name : "<LEEG>";
        item.description =(dossierItem.item.knowledge) ? dossierItem.item.knowledge : "<LEEG>";
        item.key = uuid().slice(0, 8);
        item.dayKey = day.key;
        item.state = 5;
        item.start_at = dossierItem.item.start_timeline;
        item.start_at2 = moment(dossierItem.item.start_time).format("DD-MM-YYYY HH:mm:ss");
        item.end_at = dossierItem.item.end_timeline;
        item.end_at2 = moment(dossierItem.item.end_time).format("DD-MM-YYYY HH:mm:ss");
        item.workhours = this.calculateTime(dossierItem.item.start_timeline, dossierItem.item.end_timeline, (24/4));
        item.type = 1;
        item.isOwner = true;
        item.todoType = 'dossier';
        
        
        
        return item;
    }

    static getDaysForSchedule = (date) => {
        let t = moment.updateLocale('nl', {week : {dow:1,doy:1} });
        var now = moment(date).local(t);
        var startMonth  = moment(date).local(t).startOf('month');
        var endMonth  = moment(date).local(t).endOf('month');
        let startMonthDay = startMonth.day();
        if(startMonth.day() == 0) {
            startMonthDay = 7;
        }
        let startOfCalender = startMonth.clone().subtract(startMonthDay-1, 'days');
        let revVal = {};
        let totalDays = startMonth.daysInMonth() + (7-endMonth.day());
        let index = 0;
        for(let i = (1-startMonthDay); i <= (42-startMonthDay*2); i++) {
            let isCurrentMonth = true;
            if(i < 0) {
                isCurrentMonth = false;
            } else if(i >= startMonth.daysInMonth()) {
                isCurrentMonth = false;
            }
            revVal[startOfCalender.format("YYYYMMDD")] = {key:"K_"+startOfCalender.format("YMMDD"), daykey:startOfCalender.format("YYYYMMDD"), year: parseInt(startOfCalender.format("YYYY")), month: parseInt(startOfCalender.format("MM")), weekDay: parseInt(startOfCalender.format("E")),
            day:parseInt(startOfCalender.format("DD")),date:startOfCalender.format("Y-M-D"), isCurrentMonth: isCurrentMonth, events: [], index: index};
            startOfCalender.add(1, 'day');
            
            index++;
        }
        
        return revVal;
        
        }
    static getDayKeyForDate(selectedDate = null) {
        if(!selectedDate) {
            selectedDate = moment();
        } else if (typeof selectedDate == 'number') {
            selectedDate = moment(selectedDate);
        }
        
        return "K_"+selectedDate.format("YMMDD");
    }
    
    static getDaysForMonth = (date, endMonth = null, hasMonthDivider = false) => {
        let t = moment.updateLocale('nl', {week : {dow:1,doy:1} });
        var now = moment(date).local(t);
        var startMonth  = moment(date).local(t).startOf('month');
        if(!endMonth) {
            endMonth  = moment(date).local(t).endOf('month');
        }
        let startMonthDay = startMonth.day();
        if(startMonth.day() == 0) {
            startMonthDay = 7;
        }
        let startOfCalender = startMonth.clone().subtract(startMonthDay-1, 'days');
        let revVal = new Array();
        let monthDivider = new Array();
        let currentMonth = null;
        let totalDays = 42-startMonthDay;
        if(hasMonthDivider && endMonth) {
            totalDays = endMonth.diff(startMonth, 'days');
        }
        let index = 0;
        for(let i = (1-startMonthDay); i <= totalDays; i++) {
            let isCurrentMonth = true;
            if(i < 0) {
                isCurrentMonth = false;
            } else if(i >= startMonth.daysInMonth()) {
                isCurrentMonth = false;
            }
            currentMonth = startOfCalender.format("MMMM YYYY");
            
            revVal.push({key:"K_"+startOfCalender.format("YMMDD"), daykey:startOfCalender.format("YYYYMMDD"), year: parseInt(startOfCalender.format("YYYY")), month: parseInt(startOfCalender.format("MM")), weekDay: parseInt(startOfCalender.format("E")),
            day:parseInt(startOfCalender.format("DD")),date:startOfCalender.format("Y-M-D"), isCurrentMonth: isCurrentMonth, events: [], index: index, moment: startOfCalender.clone()});
            startOfCalender.add(1, 'day');
            
            if(hasMonthDivider && (currentMonth != startOfCalender.format("MMMM YYYY") || i == totalDays)  ) {
                if(currentMonth) {
                    monthDivider.push( {month: currentMonth ,dates: revVal });
                    revVal = [];
                }
            }
            index++;
        }
        
        if(hasMonthDivider) {
            return monthDivider;
        }
        
        return revVal;
    }
    static getParentElement = (html, parentId) => {
        let founded = null;
        if(html['id'] && parentId != html['id']) {
            if(html.parentElement) {
            return this.getParentElement(html.parentElement, parentId);
            }
        } else if(html['id'] && parentId == html['id']) {
            founded = html;
            }
        return founded;
     }
        
    static checkIs = (payload, itemToCheck, items) => {
        let day = payload.day;
        let eventElement = payload['eventElement'];
        if(items[day.key]) {
        for(let i in items) {
            
        } 
        //let htmlEl = this.getParentElement(eventElement, "itemsPanel");
        //console.info("===== jhfsjfashjfjha =====", htmlEl);
        console.info(this.createEventDropElement(eventElement));
        
        } else {
            this.createEventDropElement(eventElement, true);
        }
      }
      
      static createEventDropElement = (eventElement, wholeDay = false) => {
          const newDiv = document.createElement("div");
          //newDiv.onDragOver=function(event) {event.preventDefault()}
          newDiv.classList.add("eventDrop");
          newDiv.classList.add("event");
          if(wholeDay) {
              newDiv.classList.add("wholeDay");
              const label = document.createElement("label");
              label.textContent = "Gehele dag beschikbaar";
                newDiv.appendChild(label);
                
                const subLbl = document.createElement("span");
                subLbl.textContent = "sleep het event hierin";
                newDiv.appendChild(subLbl);
                
          }
          eventElement.appendChild(newDiv);
          
          
          
          return newDiv;
      }
      
     timeCheckMe(val) {
         if(!this.testval) {
             this.testval = val;
        console.info("timeCheckMe");
         } else {
             console.info("timeCheckMe!!!!! "+val);
         }
    }
}
export default CalenderHelperClass;